import React from "react";

interface Subunit {
  subunitName: string;
  skills: string[];
}

interface Unit {
  unitName: string;
  unitDescription: string;
  subunits: Subunit[];
}

interface UnitDisplayProps {
  unit: Unit;
  unitNumber: number;
}

const UnitDisplay: React.FC<UnitDisplayProps> = ({ unit, unitNumber }) => {
  return (
    <div className="p-4">
      <h2 className="mb-2 text-xl font-bold leading-[26px]">
        Unit {unitNumber}: {unit.unitName}
      </h2>
      {unit.subunits?.length && (
        <p className="mb-2 font-sans text-sm !leading-none text-dm-charcoal-500">
          {unit.subunits?.length}{" "}
          {unit.subunits?.length === 1 ? "Section" : "Sections"}
        </p>
      )}
      <p className="mb-4 font-sans text-sm leading-[26px] text-dm-charcoal-500">
        {unit.unitDescription}
      </p>

      <div className="space-y-4">
        {unit.subunits?.map((subunit, subunitIndex) => (
          <div key={subunitIndex} className="ml-6">
            <h3 className="mb-2 text-lg font-bold text-dm-brand-blue-600">
              Section {subunitIndex + 1}: {subunit.subunitName}
            </h3>
            <ul className="space-y-1">
              {subunit.skills.map((skill, skillIndex) => (
                <p key={skillIndex} className="text-gray-700">
                  Skill {skillIndex + 1}: {skill}
                </p>
              ))}
            </ul>
          </div>
        ))}
      </div>
    </div>
  );
};

export default UnitDisplay;
